module.exports = __webpack_public_path__ + "static/media/hunt-library-ncsu-16x9-sm-1.9dee9b3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/immersive-scholar-residency-at-ncsu/hunt-library-ncsu-16x9-sm-1.jpg
// module id = 4141
// module chunks = 13